<template>
  <BlSheetMv
    :active="isShowWalletList"
    auto-height
    :is-draggable="false"
    title="Pilih e-wallet"
    class="bl-sheet"
    data-test-id="wallet-sheet"
    @close="closeModal"
  >
    <div slot="content" data-test-id="content">
      <div class="gamification-wallet-body" data-test-id="wallet-body">
        <div v-for="wallet in walletList" :key="wallet.id" class="mb-16" data-test-id="wallet-item">
          <div class="wallet-card" @click="onClickWallet(wallet)">
            <div class="flex items-center gap-4">
              <img :src="$publicUrl(`images/kartu-prakerja/wallet/${wallet.icon}`)" height="28" width="28" alt="ovo-icon" />
              <BlTextAv variation="body-14" data-test-id="wallet-name">{{ wallet.name }}</BlTextAv>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BlSheetMv>
</template>

<script>
import BlSheetMv from '../temporary-bazaar-components/BlSheetMv/BlSheetMv.vue';
import {BlTextAv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'GamificationWalletList',
  components: {
    BlSheetMv,
    BlTextAv,
  },
  props: {
    isShowWalletList: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      walletList: [
        {
          id: 'ovo',
          name: 'OVO',
          icon: 'ovo.webp',
        },
        {
          id: 'dana',
          name: 'DANA',
          icon: 'dana.webp',
        },
        {
          id: 'gopay',
          name: 'GoPay',
          icon: 'gopay.webp',
        },
      ],
    };
  },
  methods: {
    closeModal() {
      this.$emit('onUpdateShowModal', false);
    },
    onClickWallet(wallet) {
      this.$emit('onWalletClick', wallet);
    },
  },
};
</script>
<style lang="scss" scoped>
.bl-sheet {
  max-width: 480px;
  margin: 0 auto;
}
.gamification-wallet-body {
  padding: 16px;
}

.wallet-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-top: 4px;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
